import React from "react";
import { useTheme } from "@fluentui/react";

const DefaultBanner = ({ children }) => {
  const wrapped = React.Children.map(children, child => (
    <div className="banner-item">{child}</div>
  ));
  const theme = useTheme()

  const banner = <div className="header-banner grid-content"
    style={{
      backgroundColor: theme.palette.themeDark,
      color: theme.palette.white
    }}
  >{wrapped}</div>;

  return banner;
};

export default DefaultBanner;
